/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    OfficeUser,
    OfficeUserFromJSON,
    OfficeUserToJSON,
    PasswordChangeRequest,
    PasswordChangeRequestFromJSON,
    PasswordChangeRequestToJSON,
    UpdateProfileRequest,
    UpdateProfileRequestFromJSON,
    UpdateProfileRequestToJSON,
} from '../models';

export interface UpdateOfficePasswordRequest {
    passwordChangeRequest: PasswordChangeRequest;
}

export interface UpdateOfficeProfileRequest {
    updateProfileRequest: UpdateProfileRequest;
}

/**
 * 
 */
export class OfficeProfileApi extends runtime.BaseAPI {

    /**
     * プロフィール取得
     */
    async currentOfficeProfileRaw(): Promise<runtime.ApiResponse<OfficeUser>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/office/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => OfficeUserFromJSON(jsonValue));
    }

    /**
     * プロフィール取得
     */
    async currentOfficeProfile(): Promise<OfficeUser> {
        const response = await this.currentOfficeProfileRaw();
        return await response.value();
    }

    /**
     * パスワード変更
     */
    async updateOfficePasswordRaw(requestParameters: UpdateOfficePasswordRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.passwordChangeRequest === null || requestParameters.passwordChangeRequest === undefined) {
            throw new runtime.RequiredError('passwordChangeRequest','Required parameter requestParameters.passwordChangeRequest was null or undefined when calling updateOfficePassword.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/office/password`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordChangeRequestToJSON(requestParameters.passwordChangeRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * パスワード変更
     */
    async updateOfficePassword(passwordChangeRequest: PasswordChangeRequest): Promise<void> {
        await this.updateOfficePasswordRaw({ passwordChangeRequest: passwordChangeRequest });
    }

    /**
     * プロフィール変更
     */
    async updateOfficeProfileRaw(requestParameters: UpdateOfficeProfileRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.updateProfileRequest === null || requestParameters.updateProfileRequest === undefined) {
            throw new runtime.RequiredError('updateProfileRequest','Required parameter requestParameters.updateProfileRequest was null or undefined when calling updateOfficeProfile.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/office/profile`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProfileRequestToJSON(requestParameters.updateProfileRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * プロフィール変更
     */
    async updateOfficeProfile(updateProfileRequest: UpdateProfileRequest): Promise<void> {
        await this.updateOfficeProfileRaw({ updateProfileRequest: updateProfileRequest });
    }

}
